import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { componentKey } from '../../routes/RoutesSlice';
import { USER_ROLE_NAMES } from './Constants';
import IsAccessAllowed from './IsAccessAllowed';

const ShowForAllowedUsers = ({ fallback, children, navigateUrl = null, isAppointment =false }) => {

    const [isAdminUser, setIsAdminUser] = useState(true)
    const { loggedInProviderUser } = useSelector(state => state[componentKey])
    const navigate = useNavigate()


    useEffect(() => {
        let allowedRoles = [
            USER_ROLE_NAMES.ADMIN_PROVIDER,
            USER_ROLE_NAMES.PROVIDER
        ]
        if (isAppointment && loggedInProviderUser?.roleNames?.includes(USER_ROLE_NAMES.FRONT_DESK)) {
            allowedRoles = [...allowedRoles, USER_ROLE_NAMES.FRONT_DESK];
        }
        const currentRole = loggedInProviderUser?.roleNames || []
        const status = IsAccessAllowed(allowedRoles, currentRole)
        setIsAdminUser(status)
    }, [loggedInProviderUser?.roleNames])

    if (!isAdminUser) {
        if (fallback) {
            return fallback()
        } else if (navigateUrl) {
            return navigate(navigateUrl)
        }
        return <></>
    }

    return (
        <>{children}</>
    )
};
export default ShowForAllowedUsers;
